import fp from 'lodash/fp';
import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { configurations } from './configurations';

export const initialState = {
  isFetchingUser: false,
  userData: undefined,
  isFetchingReport: false,
  report: undefined,
  userStat: undefined,
  contentReport: undefined,
  businessReport: undefined,
  isPostingPublisher: false,
  lastAddedPublisher: undefined,
  isUpdating: false,
  isFetchingIndustryCpdCategory: false,
  error: null,
  industryCpdCategory: [],
  isRemovingUserQuiz: false,
  isUploadingCPD: false,
  usersForKaplanUpload: [],
  userIds: [],
  cpdAvailabilityEstimations: [],
  userEngagementEstimations: [],
  externalCpdUploadResult: [],
  isEstimatingCpdAvailability: false,
  isEstimatingUserEngagement: false,
  isUpdatingTask: false,
  isFetchingTask: false,
  adminTasks: undefined,
  isFetchingTaskGroup: false,
  adminTaskGroups: undefined,
  adminTaskGroup: undefined,
  isDeletingUser: false,
  isCopyingActivity: false,
  copyResult: null,
  externalUserData: undefined,
  isUpdatingBusinessNotes: false,
  contentRatingReport: undefined,
  isFetchingBusinessActivities: false,
  businessActivities: undefined,
  isUpdatingBusinessUploadCpdWithoutApproval: false,
};

const reducer = handleActions(
  {
    ...fp.flow(
      fp.map(
        ({ reducers: { reducer, request, success, failed }, action: { admin: { api, ...action } }, name }) => {
          var result = {}
          if (reducer) {
            result = {
              ...result,
              [action[name]().type]: reducer
            }
          }
          if (request) {
            result = {
              ...result,
              [api[name].request]: request
            }
          }
          if (success) {
            result = {
              ...result,
              [api[name].success]: success
            }
          }
          if (failed) {
            result = {
              ...result,
              [api[name].failed]: failed
            }
          }
          return result
        }
      ),
      fp.reduce(
        (prev, current) => ({
          ...prev,
          ...current
        }),
        {}
      )
    )(configurations),
    [LOCATION_CHANGE]: (state, action) => ({
      ...state,
      adminTaskGroup: undefined
    })
  },
  {
    ...initialState
  }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/admin/reducers.js